import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const WarningIcon = styled(FontAwesomeIcon)`
  color: ${(props) => props.theme.colors.warning};
`;
